/*
 * Bundle pricing for 50 States of Beauty (Turbo theme)
 * - Product page "Build Your Bundle" box + bundle price by Add to Cart
 * - Slide-out cart drawer (contents rendered by sections/bundle-cart-drawer.liquid)
 * Settings live in Theme settings → Bundle pricing (see snippets/bundle-config.liquid).
 */
(function () {
  'use strict';
  if (window.__bundlePricingLoaded) return;
  window.__bundlePricingLoaded = true;

  var C = window.BundlePricing;
  if (!C) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTION_ID = 'bundle-cart-drawer';
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;

  /* ---------------- Config helpers ---------------- */

  var TYPES = String(C.types || 'Prints').split(',')
    .map(function (s) { return s.trim().toLowerCase(); })
    .filter(Boolean);

  var TIERS = String(C.tiersRaw || '').split(',').map(function (part) {
    var bits = part.split(':');
    return { qty: parseInt(bits[0], 10), pct: parseFloat(String(bits[1] || '').replace('%', '')) };
  }).filter(function (t) {
    return t.qty > 0 && !isNaN(t.pct) && t.pct >= 0;
  }).sort(function (a, b) { return a.qty - b.qty; });

  function isCounted(type) {
    return TYPES.indexOf(String(type || '').trim().toLowerCase()) !== -1;
  }

  function pctFor(count) {
    if (C.mode === 'flat') return count > 0 ? Number(C.flatPercent) || 0 : 0;
    if (C.mode !== 'tiered') return 0;
    var pct = 0;
    TIERS.forEach(function (t) { if (count >= t.qty && t.pct > pct) pct = t.pct; });
    return pct;
  }

  function nextTier(count) {
    if (C.mode !== 'tiered') return null;
    var current = pctFor(count);
    for (var i = 0; i < TIERS.length; i++) {
      if (TIERS[i].qty > count && TIERS[i].pct > current) return TIERS[i];
    }
    return null;
  }

  function plural(n, word) { return n + ' ' + word + (n === 1 ? '' : 's'); }

  /* ---------------- Money ---------------- */

  function fmtNumber(cents, decimals, thousands, decimal) {
    var parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var format = C.moneyFormat || '${{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmtNumber(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmtNumber(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtNumber(cents, 0, '.', ','); break;
      default: value = fmtNumber(cents, 2, ',', '.');
    }
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------- Cart state ---------------- */

  var state = { printCount: 0 };

  function loadCart() {
    if (!nativeFetch) return Promise.resolve();
    return nativeFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.printCount = (cart.items || []).reduce(function (n, item) {
          return n + (isCounted(item.product_type) ? item.quantity : 0);
        }, 0);
        renderProduct();
        return cart;
      })
      .catch(function () {});
  }

  /* ---------------- Product page ---------------- */

  function currentProduct() {
    var p = window.product;
    return p && p.selected_variant && isCounted(p.type) ? p : null;
  }

  function selectedQty() {
    var el = document.querySelector('.shopify-product-form input[name="quantity"], .purchase-details input.quantity');
    var q = parseInt(el && el.value, 10);
    return q > 0 ? q : 1;
  }

  function framePrice() {
    var f = window.frame_product;
    return f && f.selected_variant ? f.selected_variant.price : 0;
  }

  function tierLabel(qty, isLast) {
    return qty + (isLast && qty > 1 ? '+' : '') + ' print' + (qty === 1 && !isLast ? '' : 's');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  // Place the box right under the size selector (works without editing the product template).
  function ensureBox() {
    var box = document.querySelector('[data-bp-box]');
    if (box) return box;
    if (!currentProduct() || C.mode === 'off' || !C.showProductBox) return null;
    var anchor = document.querySelector('.shopify-product-form .product-options-main');
    if (!anchor) return null;
    var t = C.text || {};
    box = document.createElement('div');
    box.className = 'bp-box';
    box.setAttribute('data-bp-box', '');
    box.hidden = true;
    box.innerHTML =
      '<p class="bp-box__eyebrow" data-bp-eyebrow>' + esc(t.eyebrow) + '</p>' +
      '<h3 class="bp-box__heading" data-bp-heading>' + esc(t.heading) + '</h3>' +
      '<p class="bp-box__sub">' + esc(t.subheading) + '</p>' +
      '<ul class="bp-tiers" data-bp-tiers></ul>' +
      '<p class="bp-status" data-bp-status aria-live="polite"></p>';
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
    return box;
  }

  function renderBox() {
    var box = ensureBox();
    if (!box) return;
    var p = currentProduct();
    if (!p || C.mode === 'off' || !C.showProductBox) { box.hidden = true; return; }

    var unit = p.selected_variant.price;
    var qty = selectedQty();
    var inCart = state.printCount;
    var after = inCart + qty;
    var list = box.querySelector('[data-bp-tiers]');
    var status = box.querySelector('[data-bp-status]');
    var html = '';

    if (C.mode === 'flat') {
      var fp = Number(C.flatPercent) || 0;
      box.querySelector('[data-bp-eyebrow]').textContent = 'Sale';
      box.querySelector('[data-bp-heading]').textContent = fp + '% off every print';
      html = '<li class="bp-tier is-active"><span class="bp-tier__qty">Your price</span>' +
        '<span class="bp-tier__price"><s>' + money(unit) + '</s><strong>' + money(unit * (1 - fp / 100)) + '</strong></span>' +
        '<span class="bp-tier__off">' + fp + '% off</span></li>';
      setHTML(list, html);
      setHTML(status, '');
      box.hidden = false;
      return;
    }

    if (!TIERS.length) { box.hidden = true; return; }

    var rows = [];
    if (TIERS[0].qty > 1) rows.push({ qty: 1, pct: 0 });
    rows = rows.concat(TIERS);

    var afterPct = pctFor(after);
    rows.forEach(function (t, i) {
      var isLast = i === rows.length - 1;
      var nextQty = isLast ? Infinity : rows[i + 1].qty;
      var active = after >= t.qty && after < nextQty;
      var price = unit * (1 - t.pct / 100);
      html += '<li class="bp-tier' + (active ? ' is-active' : '') + '">' +
        '<span class="bp-tier__qty">' + tierLabel(t.qty, isLast) +
          (active ? '<em class="bp-tier__here">' + (inCart > 0 ? 'with this print' : 'you are here') + '</em>' : '') +
        '</span>' +
        '<span class="bp-tier__price">' + (t.pct > 0 ? '<s>' + money(unit) + '</s>' : '') +
          '<strong>' + money(price) + '</strong><small>each</small></span>' +
        '<span class="bp-tier__off' + (t.pct > 0 ? '' : ' is-regular') + '">' + (t.pct > 0 ? t.pct + '% off' : 'Regular') + '</span>' +
      '</li>';
    });
    setHTML(list, html);

    var next = nextTier(after);
    var msg;
    if (inCart === 0) {
      if (afterPct > 0) {
        msg = 'Adding ' + plural(qty, 'print') + ' gets you <strong>' + afterPct + '% off</strong>.';
      } else if (next) {
        msg = 'Add <strong>' + plural(next.qty, 'print') + '</strong> of any design and save <strong>' + next.pct + '%</strong> on every print.';
      }
    } else {
      msg = 'You have ' + plural(inCart, 'print') + ' in your cart. ';
      if (afterPct > 0) {
        msg += 'Add this one and <strong>every print is ' + afterPct + '% off</strong>.';
      } else {
        msg += 'Add this one to keep building your bundle.';
      }
    }
    if (next && (inCart > 0 || afterPct > 0)) {
      var need = next.qty - after;
      msg += ' Add ' + plural(need, 'more print') + ' for <strong>' + next.pct + '% off</strong>.';
    } else if (!next && afterPct > 0) {
      msg += ' That’s our best bundle price!';
    }
    setHTML(status, msg || '');
    box.hidden = false;
  }

  // Only touch the DOM when something actually changed (keeps the page watcher from looping).
  function setHTML(el, html) {
    if (el.getAttribute('data-bp-html') !== html) {
      el.innerHTML = html;
      el.setAttribute('data-bp-html', html);
    }
  }

  // Writes into price elements the theme also writes to. Re-applies when the theme overwrites
  // them OR when our price changes (e.g. the cart count arrives after the page loads).
  function applyPrice(el, html) {
    if (el.innerHTML !== el.getAttribute('data-bp-html') || el.getAttribute('data-bp-src') !== html) {
      el.innerHTML = html;
      el.setAttribute('data-bp-src', html);
      el.setAttribute('data-bp-html', el.innerHTML);
    }
  }

  function renderAtcPrice() {
    if (!C.showAtcPrice || C.mode === 'off') return;
    var p = currentProduct();
    if (!p) return;
    var unit = p.selected_variant.price;
    var qty = selectedQty();
    var pct = pctFor(state.printCount + qty);
    var frame = framePrice(); // frames are never discounted
    var full = unit * qty + frame;
    var now = Math.round(unit * qty * (1 - pct / 100)) + frame;
    var html = pct > 0
      ? '<s class="bp-atc-was">' + money(full) + '</s><span class="bp-atc-now">' + money(now) + '</span>'
      : money(full);

    document.querySelectorAll('.purchase-details .total-price, .product-form-sticky .total-price').forEach(function (el) {
      applyPrice(el, html);
    });

    // Price next to the SIZE label (per print)
    var unitNow = Math.round(unit * (1 - pct / 100));
    var sizeHtml = pct > 0
      ? '<s class="bp-size-was">' + money(unit) + '</s><span class="bp-size-now">' + money(unitNow) + '</span>'
      : money(unit);
    document.querySelectorAll('.product-options-main .option_title .variant-price:not(.compare-price)').forEach(function (el) {
      applyPrice(el, sizeHtml);
    });

    var details = document.querySelector('.shopify-product-form .purchase-details');
    if (details) {
      var note = document.querySelector('.bp-atc-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'bp-atc-note';
        details.parentNode.insertBefore(note, details);
      }
      var noteText = pct > 0 ? pct + '% bundle price applied' + (frame ? ' (frame at regular price)' : '') : '';
      if (note.textContent !== noteText) note.textContent = noteText;
      note.hidden = pct === 0;
    }
  }

  var renderQueued = false;
  function renderProduct() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(function () {
      renderQueued = false;
      renderBox();
      renderAtcPrice();
    });
  }

  // The theme's product.js (and sometimes apps) rewrite or replace the price elements.
  // One watcher on the page catches every rewrite and re-applies the bundle price.
  var WATCH_SEL = '.total-price, .option_title, .product-form-sticky, .purchase-details';
  function watchTotals() {
    if (!window.MutationObserver || !document.body || document.body.__bpWatched) return;
    document.body.__bpWatched = true;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.nodeType !== 1) t = t.parentElement;
        if (t && t.closest && t.closest(WATCH_SEL)) { renderProduct(); return; }
      }
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  /* ---------------- Mobile: countdown as a slim bar under the header ---------------- */

  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 798px)') : { matches: false };

  function positionCountdownBar() {
    var bar = document.getElementById('bp-cd-bar');
    if (!bar || bar.hidden) return;
    var header = document.getElementById('header');
    var top = 0;
    if (header) {
      // offsetParent is null for a fixed header, so measure the box instead.
      var r = header.getBoundingClientRect();
      if (r.height > 0) top = Math.max(0, r.bottom);
    }
    bar.style.top = top + 'px';
    document.documentElement.style.setProperty('--bp-cd-h', bar.offsetHeight + 'px');
  }

  function placeCountdown() {
    var cd = document.getElementById('pdp-countdown');
    var bar = document.getElementById('bp-cd-bar');
    if (!cd) {
      if (bar) bar.parentNode.removeChild(bar);
      document.documentElement.classList.remove('bp-has-cd-bar');
      return;
    }
    if (!cd.__bpHome) {
      cd.__bpHome = document.createComment('bp-countdown-home');
      cd.parentNode.insertBefore(cd.__bpHome, cd);
    }
    if (MOBILE.matches) {
      if (!bar) {
        bar = document.createElement('div');
        bar.id = 'bp-cd-bar';
        bar.className = 'bp-cd-bar';
        document.body.appendChild(bar);
      }
      bar.hidden = false;
      if (cd.parentNode !== bar) bar.appendChild(cd);
      document.documentElement.classList.add('bp-has-cd-bar');
      positionCountdownBar();
    } else {
      if (bar && cd.parentNode === bar) {
        cd.__bpHome.parentNode.insertBefore(cd, cd.__bpHome);
        bar.hidden = true;
      }
      document.documentElement.classList.remove('bp-has-cd-bar');
    }
  }

  /* ---------------- Lift the chat button above the sticky Add to Cart bar ---------------- */

  var CHAT_SEL = '#shopify-chat, inbox-online-store-chat, #ShopifyChat, #dummy-chat-button-iframe, iframe#launcher';

  // Find the chat widget's fixed-position box (looks inside the widget, including its shadow DOM).
  function collectFixed(el, out, depth) {
    if (!el || depth > 5 || el.nodeType !== 1) return;
    if (getComputedStyle(el).position === 'fixed') {
      if (out.indexOf(el) === -1) out.push(el);
      return;
    }
    var kids = Array.prototype.slice.call(el.children || []);
    if (el.shadowRoot) kids = kids.concat(Array.prototype.slice.call(el.shadowRoot.children));
    kids.forEach(function (k) { collectFixed(k, out, depth + 1); });
  }

  function positionChat() {
    var lift = 0;
    var sticky = document.querySelector('.product-form-sticky');
    if (sticky) {
      var r = sticky.getBoundingClientRect();
      var visible = r.height > 0 && r.top < window.innerHeight - 4 && getComputedStyle(sticky).display !== 'none' && getComputedStyle(sticky).visibility !== 'hidden';
      if (visible) lift = Math.max(0, window.innerHeight - r.top);
    }
    var els = [];
    document.querySelectorAll(CHAT_SEL).forEach(function (el) { collectFixed(el, els, 0); });
    els.forEach(function (el) {
      el.style.transition = 'transform .25s ease';
      el.style.transform = lift ? 'translateY(-' + Math.round(lift) + 'px)' : '';
    });
  }

  var cdFrame = null;
  function onScrollResize() {
    if (cdFrame) return;
    cdFrame = requestAnimationFrame(function () { cdFrame = null; positionCountdownBar(); positionChat(); });
  }
  // The chat widget loads late and the sticky bar slides in on its own timing, so keep re-checking once a second.
  setInterval(function () { if (document.querySelector('.product-form-sticky')) positionChat(); }, 1000);
  window.addEventListener('scroll', onScrollResize, { passive: true });
  window.addEventListener('resize', function () { placeCountdown(); onScrollResize(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.promo_banner-close')) setTimeout(positionCountdownBar, 350);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-change-quantity')) setTimeout(renderProduct, 40);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('input.quantity')) renderProduct();
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input.quantity, [name="frame-finish"], [name^="option"]')) setTimeout(renderProduct, 40);
  });

  /* ---------------- Cart drawer ---------------- */

  // Build the drawer shell once per page; its contents come from sections/bundle-cart-drawer.liquid.
  function ensureDrawer() {
    if (!C.drawer || document.getElementById('BundleCartDrawer')) return;
    var d = document.createElement('div');
    d.className = 'bp-drawer';
    d.id = 'BundleCartDrawer';
    d.setAttribute('aria-hidden', 'true');
    d.innerHTML =
      '<div class="bp-drawer__overlay" data-bp-close></div>' +
      '<div class="bp-drawer__panel" role="dialog" aria-modal="true" aria-label="Shopping cart" tabindex="-1">' +
        '<div id="shopify-section-' + SECTION_ID + '" class="shopify-section"></div>' +
      '</div>';
    document.body.appendChild(d);
  }

  function drawerEl() { return document.getElementById('BundleCartDrawer'); }
  function drawerOn() { return C.drawer && !!drawerEl(); }
  function onCartPage() { return /^\/cart\/?$/.test(location.pathname.replace(ROOT, '/')); }

  var lastFocus = null;
  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bp-lock');
    var panel = d.querySelector('.bp-drawer__panel');
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 50);
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bp-lock');
    releaseScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // Turbo's (hidden) old mini cart can leave the page scroll-locked on iPhone. Clear it.
  function releaseScroll() {
    [document.documentElement, document.body].forEach(function (el) {
      if (!el) return;
      ['no-scroll', 'blocked-scroll', 'overflow-hidden', 'scroll-locked', 'noscroll'].forEach(function (c) { el.classList.remove(c); });
      if (el.style.overflow === 'hidden') el.style.overflow = '';
      if (el.style.overflowY === 'hidden') el.style.overflowY = '';
      if (el.style.position === 'fixed') {
        var y = -parseInt(el.style.top || '0', 10) || 0;
        el.style.position = ''; el.style.top = ''; el.style.width = '';
        if (y) window.scrollTo(0, y);
      }
      if (el.style.touchAction === 'none') el.style.touchAction = '';
    });
    document.querySelectorAll('.cart_container .active_link, .cart_container.active_link, .mini_cart.active_link').forEach(function (el) {
      el.classList.remove('active_link');
    });
  }

  function setLoading(on) {
    var panel = document.querySelector('#BundleCartDrawer .bp-drawer__panel');
    if (panel) panel.classList.toggle('is-loading', on);
  }

  function refreshDrawer() {
    if (!drawerOn() || !nativeFetch) return Promise.resolve();
    setLoading(true);
    return nativeFetch(ROOT + '?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + SECTION_ID);
        var current = document.getElementById('shopify-section-' + SECTION_ID);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var cartEl = document.querySelector('#BundleCartDrawer .bp-cart');
        if (cartEl) {
          var count = cartEl.getAttribute('data-bp-item-count');
          document.querySelectorAll('.cart_count').forEach(function (el) { el.textContent = count; });
          state.printCount = parseInt(cartEl.getAttribute('data-bp-print-count'), 10) || 0;
          renderProduct();
        }
      })
      .catch(function () {})
      .then(function () { setLoading(false); });
  }

  function changeLine(line, quantity) {
    setLoading(true);
    return nativeFetch(ROOT + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).catch(function () {}).then(refreshDrawer);
  }

  // Open the drawer from any cart icon (capture phase, so Turbo's own dropdown never opens).
  document.addEventListener('click', function (e) {
    if (!drawerOn() || !e.target.closest) return;
    var opener = e.target.closest('.mini_cart, [data-bp-open]');
    if (opener && !onCartPage()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
      refreshDrawer();
      return;
    }
    var closer = e.target.closest('[data-bp-close]');
    if (closer) { e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = e.target.closest('#BundleCartDrawer [data-bp-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(parseInt(qtyBtn.getAttribute('data-bp-line'), 10), Math.max(0, parseInt(qtyBtn.getAttribute('data-bp-qty'), 10) || 0));
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = drawerEl();
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });

  /* ---------------- Watch every cart change on the site ---------------- */
  // Turbo, product.js (frames) and apps all add to cart differently. Listening at the
  // network level catches all of them, then refreshes the drawer + bundle box once.

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var mutateTimer = null;
  var pendingOpen = false;

  function onCartMutated(isAdd) {
    if (isAdd) pendingOpen = true;
    clearTimeout(mutateTimer);
    mutateTimer = setTimeout(function () {
      var shouldOpen = pendingOpen && drawerOn() && !onCartPage();
      pendingOpen = false;
      refreshDrawer().then(function () {
        if (!drawerOn()) loadCart();
        if (shouldOpen) openDrawer();
      });
    }, 350);
  }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = nativeFetch(input, init);
      if (CART_RE.test(url)) {
        p.then(function (r) { if (r.ok) onCartMutated(/\/cart\/add/.test(url)); }).catch(function () {});
      }
      return p;
    };
  }

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bpUrl = String(url || '');
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (CART_RE.test(xhr.__bpUrl || '')) {
      xhr.addEventListener('load', function () {
        if (xhr.status >= 200 && xhr.status < 300) onCartMutated(/\/cart\/add/.test(xhr.__bpUrl));
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* ---------------- Init (also re-runs on Turbo's InstantClick page swaps) ---------------- */

  function init() {
    ensureDrawer();
    watchTotals();
    placeCountdown();
    renderProduct();
    // Catch the theme's own late price updates on first load.
    [300, 1000, 2500].forEach(function (ms) { setTimeout(renderProduct, ms); });
    if (drawerOn()) refreshDrawer(); else loadCart();
  }

  window.addEventListener('load', function () { renderProduct(); positionCountdownBar(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });

  init();
  if (window.InstantClick && typeof InstantClick.on === 'function') {
    InstantClick.on('change', function () {
      document.documentElement.classList.remove('bp-lock');
      init();
    });
  }
})();